import { render, staticRenderFns } from "./AboutDevice.vue?vue&type=template&id=6f73f87b&scoped=true"
import script from "./AboutDevice.vue?vue&type=script&lang=js"
export * from "./AboutDevice.vue?vue&type=script&lang=js"
import style0 from "./AboutDevice.vue?vue&type=style&index=0&id=6f73f87b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f73f87b",
  null
  
)

export default component.exports